/**
 * @internal
 */
export function isLink(element) {
    switch (element.name) {
        case "a":
        case "area":
        case "link":
            return element.attribute("href").isSome();
    }
    return false;
}
//# sourceMappingURL=is-link.js.map